import React from 'react';

import { Tooltip } from '@mui/material';

import useStyles from './styles';

interface Props {
    tooltip?: string;
    color?: 'default' | 'green' | 'red';
    className?: string;
}

const StatusTag: React.FC<Props> = ({ tooltip = null, color = 'default', className }) => {
    const { classes, cx } = useStyles();

    return (
        <Tooltip title={tooltip}>
            <span className={cx(classes.root, className)}>
                <span
                    className={cx(classes.dot, {
                        [classes._default]: color === 'default',
                        [classes._green]: color === 'green',
                        [classes._red]: color === 'red'
                    })}
                />
            </span>
        </Tooltip>
    );
};
export default StatusTag;
